// router/index.js
import Vue from 'vue'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
import Router from 'vue-router'
import Login from '@/components/Login'
import LoginHan from '@/components/LoginHan'

import axios from 'axios'
import VueAxios from 'vue-axios'
import https from '../api/https.js'; //地址根据你实际情况引入
Vue.use(https);
Vue.use(VueAxios, axios)
Vue.use(Router)
export default new Router({
  routes: [{
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        keepAlive: true
      }
    },

    {
      path: '/LoginHan',
      name: 'LoginHan',
      component: LoginHan,
      meta: {
        keepAlive: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js